import React from "react";
import { ReactComponent as ChevronRight } from "assets/images/chevron-right.svg";
import { Box, GhostButton, Text } from "components";
import useWindowDimensions from "hooks/windowDimensions";
import { useTranslation } from "react-i18next";
import { getTranslationsStyle } from "utils/arabisation.util";

import { CircleButtonStyled, StepperDots } from "./Stepper";

export default function Body({
  content,
  currentStep,
  numberOfSteps,
  onNext,
  onSkip,
}) {
  const { t, i18n } = useTranslation();
  const { height } = useWindowDimensions();

  return (
    <Box
      d="flex"
      direction="column"
      justifyContent="space-between"
      alignItems="center"
      flex="1"
      gap="s"
      pB="xl"
    >
      <Box d="flex" justifyContent="center">
        <StepperDots numberOfSteps={numberOfSteps} currentStep={currentStep} />
      </Box>
      <Box
        d="flex"
        direction="column"
        alignItems="center"
        flex="1"
        justifyContent="center"
        position="relative"
        width="100v2"
      >
        <Box
          d="flex"
          position="absolute"
          justifyContent="center"
          top={content.illustrationStyle.top}
        >
          {content.illustration &&
            React.cloneElement(content.illustration, {
              height: height,
              style: content.illustrationStyle,
            })}
        </Box>
      </Box>
      <Box
        minH="auto"
        position="absolute"
        bottom={`${height * 0.3}px`}
        w="100%"
        d="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Box w="80%">
          <Text
            style={getTranslationsStyle(i18n, { textAlign: "center" })}
            mT="m"
            fontSize="xl"
            fontWeight="semi-bold"
            color="textQuaternary"
            textAlign="center"
          >
            {t(content.description)}
          </Text>
        </Box>
      </Box>
      <Box
        d="flex"
        direction="column"
        alignItems="center"
        gap="m"
        mT="auto"
        position="absolute"
        bottom={`${height * 0.05}px`}
      >
        <CircleButtonStyled onClick={onNext} style={{ zIndex: 100 }}>
          <ChevronRight />
        </CircleButtonStyled>
        <GhostButton onClick={onSkip} style={{ color: "#fff" }}>
          {t("smart_gate.guide_skip_button_text")}
        </GhostButton>
      </Box>
    </Box>
  );
}
